import React, { useMemo } from 'react';
import { useTheme } from '../context/ThemeContext';
import leaderboardData from '../data/leaderboard.json';

function Leaderboard() {
  const { isDark } = useTheme();
  const currentVersion = "v1";
  const totalScore = leaderboardData.leaderboards[currentVersion].total_score;

  const sortedLeaderboard = useMemo(() => {
    const models = leaderboardData.leaderboards[currentVersion].models_agents_score;
    return models
      .sort((a, b) => {
        const scoreA = a.score === "TBD" ? 0 : parseInt(a.score);
        const scoreB = b.score === "TBD" ? 0 : parseInt(b.score);
        return scoreB - scoreA;
      })
      .map((entry, index) => ({
        ...entry,
        rank: index + 1
      }));
  }, [currentVersion]);

  const calculatePercentage = (value, total) => {
    if (value === "TBD") return null;
    return `(${Math.round((parseInt(value) / total) * 100)}%)`;
  };

  const calculateScorePercentage = (score) => {
    if (score === "TBD") return null;
    const scoreValue = parseInt(score);
    return `(${Math.round((scoreValue / totalScore) * 100)}%)`;
  };

  const formatScore = (score) => {
    if (score === "TBD") return "TBD";
    return `${score}`;
  };

  const totalChallenges = leaderboardData.leaderboards[currentVersion].total_challenges;

  return (
    <div className="max-w-4xl mx-auto">
      <h1 className={`text-3xl font-bold mb-4 text-center ${isDark ? 'text-hack-accent' : 'text-cyan-600'}`}>Leaderboard</h1>
      
      <div className={`rounded-lg overflow-hidden shadow-lg border transition-colors duration-200 ${isDark ? 'bg-hack-secondary border-gray-600/20' : 'bg-white border-gray-200'}`}>
        <table className="w-full">
          <thead>
            <tr className={`border-b transition-colors duration-200 ${isDark ? 'border-gray-600/20 bg-hack-primary/50' : 'border-gray-200 bg-gray-50'}`}>
              <th className={`px-4 py-3 text-left font-semibold ${isDark ? 'text-gray-100' : 'text-gray-800'}`}>Rank</th>
              <th className={`px-4 py-3 text-left font-semibold ${isDark ? 'text-gray-100' : 'text-gray-800'}`}>Model</th>
              <th className={`px-4 py-3 text-left font-semibold ${isDark ? 'text-gray-100' : 'text-gray-800'}`}>
                Score
                <div className={`text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                  Total: {totalScore}
                </div>
              </th>
              <th className={`px-4 py-3 text-left font-semibold ${isDark ? 'text-gray-100' : 'text-gray-800'}`}>Exploited</th>
              <th className={`px-4 py-3 text-left font-semibold ${isDark ? 'text-gray-100' : 'text-gray-800'}`}>Identified</th>
            </tr>
          </thead>
          <tbody>
            {sortedLeaderboard.map((entry) => (
              <tr key={entry.rank} className={`border-t transition-colors duration-200 ${isDark ? 'border-hack-accent/10 hover:bg-hack-accent/5' : 'border-gray-100 hover:bg-gray-50'}`}>
                <td className={`px-4 py-3 font-semibold whitespace-nowrap ${isDark ? 'text-hack-accent' : 'text-cyan-600'}`}>#{entry.rank}</td>
                <td className={`px-4 py-3 font-medium ${isDark ? 'text-gray-100' : 'text-gray-800'}`}>
                  <div className="whitespace-nowrap">{entry.model}</div>
                  {entry.sub_models && entry.sub_models.length > 0 && (
                    <div className={`text-xs whitespace-nowrap ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                      {entry.sub_models.join(', ')}
                    </div>
                  )}
                </td>
                <td className={`px-4 py-3 font-medium ${isDark ? 'text-gray-100' : 'text-gray-800'} whitespace-nowrap`}>
                  {formatScore(entry.score)} {calculateScorePercentage(entry.score)}
                </td>
                <td className={`px-4 py-3 ${isDark ? 'text-gray-300' : 'text-gray-700'} whitespace-nowrap`}>
                  {entry.exploited} {calculatePercentage(entry.exploited, totalChallenges)}
                </td>
                <td className={`px-4 py-3 ${isDark ? 'text-gray-300' : 'text-gray-700'} whitespace-nowrap`}>
                  {entry.identified} {calculatePercentage(entry.identified, totalChallenges)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Leaderboard;
